import React from "react";
import { ButtonDropdown } from "@bloomberg/media-ui-dropdown";
import { ChevronRight } from "@bloomberg/media-ui-icons";
import { DropdownOption } from "@bloomberg/media-ui-dropdown/types";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import styles from "./wrappedHeader.module.css";
import { addPageAction } from "~utils/newrelic/newrelicBrowser";

type WrappedHeaderProps = {
  watchlistOptions: Array<DropdownOption>;
  selectedWatchlistOption?: DropdownOption;
  onWatchlistChange: (option: DropdownOption) => void;
};

const SECTION_TITLE = "Watchlist Performance";

export function WrappedHeader({
  watchlistOptions,
  selectedWatchlistOption,
  onWatchlistChange,
}: WrappedHeaderProps) {
  const YOUR_WATCHLIST_URL = `/markets/watchlist?watchlist=${selectedWatchlistOption?.value}`;

  const onSelect = (option?: DropdownOption | null) => {
    trackClickEvent(
      "watchlistTabSwitch",
      "dropdown_switch",
      "click",
      "watchlist"
    );

    if (option && onWatchlistChange) {
      onWatchlistChange(option);
      addPageAction("wrappedWatchlistChange");
    }
  };

  const handleGoToWatchlist = () => {
    addPageAction("wrappedGoToWatchlist");
  };

  return (
    <div className={styles.headingContainer}>
      {/* Mobile Layout */}
      <div className={styles.mobileHeader}>
        <div className={styles.mobileTopRow}>
          <div className={styles.headingTitle}>{SECTION_TITLE}</div>
          <a
            className={styles.yourWatchlistMobile}
            href={YOUR_WATCHLIST_URL}
            onClick={handleGoToWatchlist}
            rel="noopener noreferrer"
          >
            <span className={styles.watchlistWrapText}>Go to Watchlist</span>
            <span className={styles.inlineIcon}>
              <ChevronRight />
            </span>
          </a>
        </div>

        <ButtonDropdown
          className={styles.watchlistViewDropdown}
          onSelect={onSelect}
          selectedItemOverride={selectedWatchlistOption}
          options={watchlistOptions}
        />
      </div>

      {/* Desktop Layout */}
      <div className={styles.desktopHeader}>
        <div className={styles.desktopHeaderMain}>
          <div className={styles.headingTitle}>{SECTION_TITLE}</div>
          <ButtonDropdown
            className={styles.watchlistViewDropdown}
            onSelect={onSelect}
            selectedItemOverride={selectedWatchlistOption}
            options={watchlistOptions}
          />
        </div>
        <a
          className={styles.yourWatchlist}
          href={YOUR_WATCHLIST_URL}
          onClick={handleGoToWatchlist}
          target="_blank"
          rel="noopener noreferrer"
        >
          View Your Watchlist
          <ChevronRight />
        </a>
      </div>
    </div>
  );
}
